import { useResource } from '@landsbankinn/l16n';
import { Col } from '@landsbankinn/ui-kit';
import { Loading } from 'src/components/Loading/Loading';
import { type PkiSimHubData } from 'src/services/ElectronicIdHubService';
import { useElectronicIdSubscriber } from '../../hooks/useElectronicIdSubscriber';
import { useSetDebugUrl } from '../../hooks/useSetDebugUrl';
import { res } from './PkiSimCode.res';

export function PkiSimCode() {
  const { r } = useResource();
  const { data } = useElectronicIdSubscriber<PkiSimHubData>('PKISim');

  useSetDebugUrl(
    data?.debugStateId
      ? `/ElectronicId/Mock?id=${data.debugStateId}`
      : undefined,
  );
  const description = data?.holdingPageSigningMessage
    ? data.holdingPageSigningMessage
    : data?.code
      ? r(res.loadingPKISIMDescription(data.code))
      : '';
  return <PkiSimLoading description={description} />;
}

type PkiSimLoadingWithCodeProps = { code: string };
export function PkiSimLoadingWithCode({ code }: PkiSimLoadingWithCodeProps) {
  const { r } = useResource();
  const description = code ? r(res.loadingPKISIMDescription(code)) : '';
  return (
    <Col>
      <PkiSimLoading description={description} />
    </Col>
  );
}

type PkiSimLoadingProps = { description: string };
function PkiSimLoading({ description }: PkiSimLoadingProps) {
  const { r } = useResource();
  const title = r(res.loadingPKISIMTitle);
  return (
    <>
      <Loading title={title} description={description} />
    </>
  );
}
